module.exports = __webpack_public_path__ + "img/Weapon_02.ed4c0518.png";